module.exports = __webpack_public_path__ + "static/media/graficas.4df6abcc.jpg";